import { UPDATE_NEEDS } from 'src/assets/images'
import { EDIT_NEEDS } from 'src/utils/routes'
import { Layout, PopUpButtonLink } from './styles'

export const UpdateNeeds = () => (
  <Layout>
    <h2>ニーズ情報を更新してください</h2>
    <img src={UPDATE_NEEDS} alt="ニーズ情報を更新してください" />
    <p>
      定期的にニーズを更新することで、検索順位が上がります。またあなたの抱えてるニーズを解決する会社からコンタクトが来やすくなります。
    </p>
    <PopUpButtonLink href={EDIT_NEEDS}>ニーズを更新する</PopUpButtonLink>
  </Layout>
)
